import { useUploadCategoryImageMutation } from '../api/categoryApi';

export interface PendingImage {
  id: string;
  /** Для сообщения о неудаче. */
  name: string;
  file: File;
}

/** Предупреждение, если часть фото не загрузилась: записи уже созданы, фото можно добавить позже. */
export function photoFailureMessage(failedNames: string[], target: 'группы' | 'категории'): string {
  return `Фото не загрузилось у: ${failedNames.map((n) => `«${n}»`).join(', ')}. Добавьте его позже в окне ${target}`;
}

/**
 * §2.1: фото при создании необязательно, а создание идёт отдельным запросом раньше. Этот хук
 * догружает фото к только что созданным категориям и никогда не бросает: категория уже есть,
 * фото можно добавить позже, поэтому неудачи возвращаются списком названий, а не ошибкой.
 */
export function useUploadPendingImages(): (items: PendingImage[]) => Promise<string[]> {
  const [uploadImage] = useUploadCategoryImageMutation();

  return async (items) => {
    const failed: string[] = [];
    for (const item of items) {
      try {
        await uploadImage({ id: item.id, file: item.file }).unwrap();
      } catch {
        failed.push(item.name);
      }
    }
    return failed;
  };
}
